<template>
  <div id="homeMain">
    <div class="colspan">
      <el-carousel
        :interval="5000"
        arrow="always"
        height="450px"
        class="lbFather"
        style="width:100%;margin-top:12px"
      >
        <el-carousel-item v-for="item in lbList" :key="item.id">
          <a v-if="item.target_type==1" :href="item.url" target="_blank">
            <img :src="item.pic_id_text.url" class="lubotu" :alt="item.title" />
            <p class="title">{{item.title}}</p>
          </a>
          <a :href="item.url" v-else>
            <img :src="item.pic_id_text.url" class="lubotu" :alt="item.title" />
            <p class="title">{{item.title}}</p>
          </a>
        </el-carousel-item>
      </el-carousel>
      <div class="information clearfix">
        <div class="information-left clearfix">
          <div class="information-left-header clearfix">
            <i></i>
            <p class="p1 clearfix">
              <img :src="newsImg" alt />
              {{recommendData1.title}}
            </p>
            <p @click="gotoDocument(recommendData1.channel_id)" class="p2 clearfix">更多></p>
          </div>
          <div
            class="information-left-main clearfix"
            v-for="(item,index) in recommendData1.new_data "
            v-if="index==0"
            :key="index"
          >
            <div
              class="left clearfix"
              @click="goto(item.id,recommendData1.template,recommendData1.channel_id)"
            >
              <router-link :to="{name:'pubDetails',query:{type:1,newsId:item.id}}">
                <div class="img_box">
                  <img v-if="item.cover_photo_text" v-lazy="item.cover_photo_text.url" alt />
                </div>
              </router-link>
            </div>
            <div class="right clearfix">
              <router-link
                :to="{name:'pubDetails',query:{type:1,newsId:item.id}}"
                style="text-decoration:none"
              >
                <div class="right_top">
                  <h3
                    :title="item[getTemplate(recommendData1.template).title]"
                    @click="goto(item.id,recommendData1.template,recommendData1.channel_id)"
                  >{{item[getTemplate(recommendData1.template).title]}}</h3>
                  <div v-if="item.if_new==1" class="icon">new</div>
                </div>
                <p>{{item[getTemplate(recommendData1.template).desc]}}</p>
              </router-link>
              <router-link
                :to="{name:'pubDetails',query:{type:1,newsId:item.id}}"
                style="text-decoration:none"
              >详情</router-link>
            </div>
          </div>
          <div class="information-left-bottom clearfix">
            <i></i>
            <div class="left">
              <ul>
                <li
                  v-if="index!=0"
                  @click="goto(item.id,recommendData1.template,recommendData1.channel_id,item)"
                  v-for="(item,index) in recommendData1.new_data"
                >
                  <div>
                    <i></i>
                    <div
                      :title="item[getTemplate(recommendData1.template).title]"
                      class="new_title"
                    >{{item[getTemplate(recommendData1.template).title]}}</div>
                    <div v-if="item.if_new==1" class="icon">new</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="information-right" v-if="$store.state.webInfo.style!='yueyang'">
          <div class="information-right-header clearfix">
            <i></i>
            <p class="p1 clearfix">
              <img :src="shieldImg" align="center" />
              <span>{{recommendData2.title}}</span>
            </p>
            <p @click="gotoDocument(recommendData2.channel_id)" class="p2 clearfix">更多></p>
          </div>
          <div class="information-right-main clearfix">
            <div class="left">
              <span></span>
              <span>NEW</span>
              <i></i>
            </div>
            <div
              v-if="recommendData2['new_data'] &&recommendData2['new_data'].length>0"
              @click="goto(recommendData2['new_data'][0].id,recommendData2.template,recommendData2.channel_id)"
              class="right"
            >
              <p>{{recommendData2['new_data'] &&recommendData2['new_data'][0][getTemplate(recommendData2.template).title]}}</p>
            </div>
          </div>
          <div class="information-right-bottom clearfix">
            <i></i>
            <div class="main">
              <ul v-if="recommendData2['new_data']&&recommendData2['new_data'].length>0">
                <li
                  @click="goto(item.id,recommendData2.template,recommendData2.channel_id,item)"
                  v-for="(item,index) in recommendData2.new_data"
                  v-if="index!=0"
                  :key="index"
                >
                  <i></i>
                  <div
                    :title="item[getTemplate(recommendData2.template).title]"
                    class="new_title"
                  >{{item[getTemplate(recommendData2.template).title]}}</div>
                  <div v-if="item.if_new==1" class="icon">new</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="love_box" v-else>
          <div class="love">
            <div class="love_title">爱心捐赠</div>
            <div class="love_bottom">
              <div class="amount clearfix">
                <div>捐赠总额</div>
                <div>{{amount}}</div>
                <div>元</div>
              </div>
              <div class="count clearfix">
                <div>捐赠人次</div>
                <div>{{count}}</div>
                <div>人次</div>
              </div>
            </div>
          </div>
          <div class="love_box_right">
            <i></i>
            <div class="love_box_header clearfix">
              <i></i>
              <p class="p1 clearfix">
                <img :src="loveImg" align="center" />
                <span>爱心捐赠</span>
              </p>
              <div class="more" @click="gotoMore(tempList4[9].value.channel_id)">更多></div>
            </div>
            <div class="love_box_bottom clearfix">
              <div class="main">
                <vue-seamless-scroll :data="donationList" class="seamless-warp">
                  <ul id="ul">
                    <li v-for="(item) in donationList" :key="item.id">
                      <i></i>
                      <p>{{item.pub_name||item.name}}</p>
                      <span>￥{{item.money}}</span>
                    </li>
                  </ul>
                </vue-seamless-scroll>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  props: {
    tempList1: {
      type: Object,
      default: function() {
        return {};
      }
    },
    tempList2: {
      type: Object,
      default: function() {
        return {};
      }
    },
    donationList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    tempList4: {
      type: Array,

      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      recommendData1: {},
      recommendData2: {},
      lbList: [],
      style: "shaodong",
      shieldImg: require("../../assets/images/shaodong/icon_shield.png"),
      newsImg: require("../../assets/images/shaodong/news.png"),
      loveImg: require("../../assets/images/yueyang/love.png"),
      amount: "",
      count: ""
    };
  },
  methods: {
    gotoMore(id) {
      if (id) {
        this.$db
          .get(this.$url.channel.url + "/" + id)
          .then(resp => {
            let data = resp.data;
            this.channelGoto(data);
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    gotoDocument(value) {
      value = Number(value);
      this.$db
        .get(this.$url.channel.url + "/" + value)
        .then(res => {
          let path_params = {};
          path_params = this.getTemplate(res.data.template);
          let param = "";
          if (res.data.pid == 0) {
            this.$router.push({
              path: path_params.path,
              query: { id: res.data.id }
            });
          } else {
            this.$router.push({
              path: path_params.path,
              query: { id: res.data.pid, second_navId: res.data.id }
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    goto(id, template, channel_id, item) {
      channel_id = Number(channel_id);
      this.$db
        .get(this.$url.channel.url + "/" + channel_id)
        .then(res => {
          if (res.data.pid == 0) {
            if (template == 1 || template == 2) {
              this.$router.push({
                name: "projectDetail",
                query: { projectInfoId: id, id: channel_id }
              });
            } else if (template == 4 || template == 3) {
              if (item&&item.type == 4) {
                this.channelGoto(item);
                return false;
              }
              this.$router.push({
                name: "details",
                query: { newsId: id, id: channel_id }
              });
            }
          } else {
            if (template == 1 || template == 2) {
              this.$router.push({
                name: "projectDetail",
                query: {
                  projectInfoId: id,
                  id: res.data.pid,
                  second_navId: res.data.id
                }
              });
            } else if (template == 3 || template == 4) {
              if (item&&item.type == 4) {
                this.channelGoto(item);
                return false;
              }
              this.$router.push({
                name: "details",
                query: {
                  newsId: id,
                  id: channel_id,
                  id: res.data.pid,
                  second_navId: res.data.id
                }
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    getListData(id, limit, index) {
      if (id) {
        let params = {};
        params.id_arr = id;
        params.template_data_page_size = limit;
        params.if_recommend = 1;
        this.$db
          .get(this.$url.channel.list, params)
          .then(resp => {
            if (resp.code == 200) {
              let arr = {};
              if (resp.data && resp.data[0]) {
                let data = resp.data[0];
                arr.title = data.title ? data.title : "";
                arr.channel_id = data.channel_id;
                arr.template = data.template;
                arr.new_data = data.template_data_list.data;
              }
              if (index == 1) {
                this.recommendData1 = arr;
              } else if (index == 2) {
                this.recommendData2 = arr;
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    //数字格式化(每三位加逗号)
    toThousands(num) {
      var num = (num || 0).toString(),
        result = "";
      while (num.length > 3) {
        result = "," + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
      }
      if (num) {
        result = num + result;
      }
      return result;
    },
    //获取捐赠信息
    getDonationInfo() {
      this.$db
        .get(this.$url.donation.index)
        .then(res => {
          if (res.code == 200) {
            this.amount = this.toThousands(Math.round(res.data.donation_sum));
            this.count = this.toThousands(res.data.donation_count);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    ...mapActions(["getWebconfigInfo"])
  },
  created() {
    //获取轮播图
    this.$db
      .get(this.$url.ads.list)
      .then(res => {
        this.lbList = res.data;
      })
      .catch(err => {
        console.log(err);
      });
    this.getWebconfigInfo()
      .then(res => {
        this.style = res.style ? res.style : "";
        if (this.style) {
          this.shieldImg = require("../../assets/images/" +
            this.style +
            "/icon_shield.png");
          this.newsImg = require("../../assets/images/" +
            this.style +
            "/news.png");
        }
      })
      .catch(err => {
        console.log(err);
      });
    this.getDonationInfo();
  },
  watch: {
    tempList1: function(value) {
      this.tempList1 = value;
      if (this.tempList1 && this.tempList1.value) {
        this.getListData(
          this.tempList1.value.channel_id,
          this.tempList1.value.limit,
          this.tempList1.index
        );
      }
    },
    tempList2: function(value) {
      this.tempList2 = value;
      if (this.tempList2 && this.tempList2.value) {
        this.getListData(
          this.tempList2.value.channel_id,
          this.tempList2.value.limit,
          this.tempList2.index
        );
      }
    }
  }
};
</script>
<style lang="less" scoped>
.colspan {
  margin: 0 auto;
  width: 1200px;
}
.lbFather {
  position: relative;
}
.lubotu {
  color: #333;
  width: 100%;
  height: 100%;
  border: none;
}
.title {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-size: 21px;
  color: #fff;
  padding: 0 15px;
}
.lbFather .title {
  margin-bottom: 0px;
}
.information {
  margin-top: 20px;
  height: 450px;
  width: 100%;
  background-color: #fff;
  position: relative;
  > .information-left {
    float: left;
    height: 100%;
    width: 810px;
    border: solid 1px #e5e5e5;
    box-sizing: border-box;
    padding: 0 16px;
    > .information-left-header {
      > i {
        width: 104px;
        height: 2px;
        position: absolute;
        left: 20px;
        top: 0;
      }
      > .p1 {
        float: left;
        font-size: 20px;
        font-family: MicrosoftYaHei-Bold;
        margin: 0;
        line-height: 50px;
        font-weight: 700;
      }
      > .p2 {
        float: right;
        color: #ccc;
        cursor: pointer;
        font-size: 14px;
      }
    }
    > .information-left-main {
      float: left;
      width: 100%;
      > .left {
        float: left;
        width: 200px;
        overflow: hidden;
        .img_box {
          width: 200px;
          height: 150px;
          overflow: hidden;
          img {
            width: 100%;
            // height: 100%;
            transition: all 0.6s;
            cursor: pointer;
          }
          img:hover {
            transform: scale(1.4);
          }
        }
      }
      > .right {
        margin-left: 220px;
        margin-top: -20px;
        .right_top {
          display: flex;
          position: relative;
          h3 {
            width: 90%;
            color: #404040;
            cursor: pointer;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          h3:hover {
            text-decoration: underline;
          }
          .icon {
            width: 38px;
            height: 18px;
            line-height: 18px;
            border: 1px solid #ea373b;
            font-weight: normal;
            font-size: 14px;
            text-align: center;
            border-radius: 3px;
            color: #ea373b;
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
          }
        }
        p {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 4;
          overflow: hidden;
          font-size: 14px;
          color: #888888;
        }
      }
    }
    > .information-left-bottom {
      position: relative;
      margin-top: 170px;
      height: 100px;
      width: 100%;
      > i {
        width: 100%;
        height: 1px;
        background-color: #ccc;
        position: absolute;
        left: 0;
        top: 0;
      }
      > .left {
        width: 100%;
        float: left;
        ul {
          display: flex;
          flex-flow: wrap row;
          justify-content: left;
          align-items: center;
          list-style-type: none;
          padding-left: 0;
          padding-top: 20px;
          margin: 0;
          overflow: hidden;
          width: 100%;
        }
        ul li {
          display: inline-block;
          width: 45%;
          list-style: disc;
        }
        ul li > div {
          width: 100%;
          position: relative;
          flex: 0 1 45%;
          padding: 5px 0;
          font-size: 16px;
          color: #404040;
          box-sizing: border-box;
          padding-left: 10px;
          cursor: pointer;
          display: flex;
          > i {
            position: absolute;
            left: 0;
            top: 50%;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            transform: translateY(-50%);
          }
          .new_title {
            width: 80%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .icon {
            width: 38px;
            height: 18px;
            line-height: 18px;
            border: 1px solid #ea373b;
            font-weight: normal;
            font-size: 14px;
            text-align: center;
            border-radius: 3px;
            color: #ea373b;
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
          }
        }
        ul li:nth-of-type(even) {
          margin-left: 10%;
        }
        // ul li::before {
        //     content: "•";
        //     color: #000;
        //     padding-right: 8px;
        // }
      }
      // > .right {
      //     width: 40%;
      //     float: left;
      //     margin-left: 15%;
      //     ul {
      //         list-style-type: none;
      //         padding-left: 0;
      //         padding-top: 20px;
      //         margin: 0;
      //         overflow: hidden;
      //     }
      //     ul li {
      //         padding: 5px 0;
      //         font-size: 16px;
      //         color: #404040;
      //         overflow: hidden;
      //         text-overflow:ellipsis;
      //         white-space: nowrap;
      //     }
      //     ul li::before {
      //         content: "❁";
      //         color: red;
      //         padding-right: 8px;
      //     }
      // }
    }
  }
  > .information-right {
    float: left;
    margin-left: 20px;
    height: 100%;
    width: calc(100% - 830px);
    box-sizing: border-box;
    border: solid 1px #e5e5e5;
    padding: 0 16px;
    position: relative;
    > .information-right-header {
      > i {
        width: 104px;
        height: 2px;
        position: absolute;
        left: 16px;
        top: 0;
      }
      > .p1 {
        float: left;
        font-size: 20px;
        font-family: MicrosoftYaHei-Bold;
        margin: 0;
        line-height: 50px;
        font-weight: 700;
      }
      > .p2 {
        float: right;
        color: #ccc;
        cursor: pointer;
        font-size: 14px;
      }
    }
    > .information-right-main {
      height: 80px;
      width: 100%;
      > .left {
        width: 80px;
        height: 100%;
        float: left;
        color: #fff;
        padding: 18px 20px;
        box-sizing: border-box;
        position: relative;
        span {
          text-align: center;
        }
        i {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 0;
          height: 0;
          border-top: 15px solid transparent;
          border-bottom: 15px solid transparent;
          transform: translateY(50%);
        }
      }
      > .right {
        cursor: pointer;
        background-color: #f3f3f3;
        width: calc(100% - 80px);
        height: 100%;
        float: left;
        font-size: 14px;
        line-height: 24px;
        color: #404040;
        box-sizing: border-box;
        p {
          padding: 0 10px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
      > .right:hover {
        text-decoration: underline;
      }
    }
    > .information-right-bottom {
      position: relative;
      height: 100px;
      width: 100%;
      > i {
        width: 100%;
        height: 1px;
        background-color: #ccc;
        position: absolute;
        left: 0;
        top: 30px;
      }
      > .main {
        width: 100%;
        float: left;
        ul {
          list-style-type: none;
          padding-left: 0;
          padding-top: 20px;
          margin-top: 24px;
        }
        ul li {
          position: relative;
          padding: 5px 0;
          font-size: 16px;
          color: #404040;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-left: 10px;
          cursor: pointer;
          > i {
            position: absolute;
            left: 0;
            top: 50%;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            transform: translateY(-50%);
          }
          .new_title {
            width: 80%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .icon {
            width: 38px;
            height: 18px;
            line-height: 18px;
            border: 1px solid #ea373b;
            font-weight: normal;
            font-size: 14px;
            text-align: center;
            border-radius: 3px;
            color: #ea373b;
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
          }
        }
      }
    }
  }
}
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: ".";
  clear: both;
  height: 0;
}
.el-carousel__container.el-carousel__arrow {
  height: 55px;
  width: 55px;
}

.love_box {
  float: left;
  width: calc(100% - 830px);
  box-sizing: border-box;
  height: 100%;
  margin-left: 20px;
  > .love {
    width: 370px;
    height: 140px;
    margin-bottom: 20px;
    background: url("../../assets/images/yueyang/donation.png");
    overflow: hidden;
    .love_title {
      margin: 16px 0 20px;
      color: #fff;
      font-size: 18px;
      text-align: center;
      font-weight: 550;
      font-family: myFont;
    }
    .love_bottom {
      color: #fff;
      padding: 0 30px;
      .amount,
      .count {
        margin-bottom: 20px;
        font-family: myFont;
        div:nth-of-type(1) {
          float: left;
        }
        div:nth-of-type(2) {
          width: 214px;
          font-size: 20px;
          line-height: 14px;
          font-family: myFont;
          display: inline-block;
          text-align: center;
        }
        div:nth-of-type(3) {
          float: right;
        }
      }
    }
  }
  > .love_box_right {
    float: left;
    height: 289px;
    width: 100%;
    box-sizing: border-box;
    border: solid 1px #e5e5e5;
    padding: 0 16px;
    position: relative;
    overflow: hidden;
    > i {
      width: 100%;
      height: 1px;
      background-color: #ccc;
      position: absolute;
      left: 0;
      top: 50px;
    }
    > .love_box_header {
      position: relative;
      z-index: 9999;
      height: 50px;
      > i {
        width: 110px;
        height: 2px;
        position: absolute;
        left: 0;
        top: 0;
      }
      > .p1 {
        float: left;
        font-size: 20px;
        font-family: MicrosoftYaHei-Bold;
        margin: 0;
        font-weight: 700;
        line-height: 50px;
        > span {
          color: #3f69b0;
        }
      }
      > .p2 {
        float: right;
        color: #ccc;
        cursor: pointer;
        font-size: 14px;
        margin: 0;
        line-height: 50px;
      }
      .more {
        cursor: pointer;
        color: #888;
        font-size: 14px;
        height: 50px;
        line-height: 50px;
        float: right;
      }
    }
    > .love_box_bottom {
      width: 100%;
      overflow: hidden;
      > .main {
        width: 100%;
        height: 100%;
        float: left;
        overflow: hidden;
        > .seamless-warp {
          height: 100%;
          overflow: hidden;
        }
        ul {
          width: 100%;
          height: 200%;
          list-style-type: none;
          padding-left: 0;
          margin: 0;
          overflow: hidden;
        }
        ul li {
          font-size: 16px;
          color: #404040;
          // overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          position: relative;
          height: 38px;
          line-height: 38px;
          box-sizing: border-box;
          > i {
            width: 100%;
            height: 1px;
            background-color: #ccc;
            position: absolute;
            left: 0;
            bottom: 1px;
          }

          > p {
            float: left;
            margin: 0;
            color: #404040;
          }
          > span {
            float: right;
            font-size: 14px;
          }
        }
      }
    }
  }
  .love_box {
    > .love {
      float: left;
      width: 370px;
      height: 140px;
      margin-left: 20px;
      margin-bottom: 20px;
      .title {
        margin: 16px 0 20px;
        color: #fff;
        font-size: 18px;
        text-align: center;
        font-weight: 550;
        font-family: myFont;
      }
      .love_bottom {
        color: #fff;
        padding: 0 30px;
        .amount,
        .count {
          margin-bottom: 20px;
          font-family: myFont;
          div:nth-of-type(1) {
            float: left;
          }
          div:nth-of-type(2) {
            width: 214px;
            font-size: 20px;
            line-height: 14px;
            font-family: myFont;
            display: inline-block;
            text-align: center;
          }
          div:nth-of-type(3) {
            float: right;
          }
        }
      }
    }
    > .information-right {
      float: left;
      margin-left: 20px;
      height: 310px;
      width: calc(100% - 830px);
      box-sizing: border-box;
      border: solid 1px #e5e5e5;
      padding: 0 16px;
      position: relative;
      overflow: hidden;
      > i {
        width: 100%;
        height: 1px;
        background-color: #ccc;
        position: absolute;
        left: 0;
        top: 50px;
      }
      > .information-right-header {
        position: relative;
        z-index: 9999;
        height: 50px;
        > i {
          width: 110px;
          height: 2px;
          position: absolute;
          left: 0;
          top: 0;
        }
        > .p1 {
          float: left;
          font-size: 20px;
          font-family: MicrosoftYaHei-Bold;
          margin: 0;
          font-weight: 700;
          line-height: 50px;
        }
        > .p2 {
          float: right;
          color: #ccc;
          cursor: pointer;
          font-size: 14px;
          margin: 0;
          line-height: 50px;
        }
        .more {
          cursor: pointer;
          color: #888;
          font-size: 14px;
          height: 50px;
          line-height: 50px;
          float: right;
        }
      }
      > .information-right-bottom {
        width: 100%;
        overflow: hidden;
        > .main {
          width: 100%;
          height: 100%;
          float: left;
          overflow: hidden;
          > .seamless-warp {
            height: 100%;
            overflow: hidden;
          }
          ul {
            width: 100%;
            height: 200%;
            list-style-type: none;
            padding-left: 0;
            margin: 0;
            overflow: hidden;
          }
          ul li {
            font-size: 16px;
            color: #404040;
            // overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            position: relative;
            height: 38px;
            line-height: 38px;
            box-sizing: border-box;
            > i {
              width: 100%;
              height: 1px;
              background-color: #ccc;
              position: absolute;
              left: 0;
              bottom: 1px;
            }

            > p {
              float: left;
              margin: 0;
              color: #404040;
            }
            > span {
              float: right;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Home/main.vue